// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consumer-type-static:after { content: none; }`, "",{"version":3,"sources":["webpack://./apps/icamppro-gateway-portal/src/components/camper-registration/camper-registration.component.ts"],"names":[],"mappings":"AAAA,8BAA8B,aAAa,EAAE","sourcesContent":[".consumer-type-static:after { content: none; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
